import React from 'react';

import { cn } from 'lib/helpers/utility';

/**
 * @param {import('./lib/propTypes').DividerProps} props
 */

const Divider = ({
  direction = 'horizontal',
  className = '',
  color = 'neutral-200',
  width = 'w-full',
  height = 'h-full',
  text
}) => {
  const lineStyles =
    direction === 'horizontal' ? `h-[1px] ${width} bg-${color}` : `w-[1px] ${height} bg-${color}`;

  if (text && direction === 'horizontal') {
    return (
      <div className={cn('flex items-center', width, className)}>
        <div className={cn('h-[1px] flex-1', `bg-${color}`)} />
        <span className="px-4 text-sm text-neutral-500">{text}</span>
        <div className={cn('h-[1px] flex-1', `bg-${color}`)} />
      </div>
    );
  }

  return <div className={cn(lineStyles, className)} />;
};

export default Divider;
